export const heroStats = [
  { value: '120+', labelKey: 'hero.stat.projects' },
  { value: '12', labelKey: 'hero.stat.chains' },
  { value: '99.98%', labelKey: 'hero.stat.uptime' },
  { value: '40', labelKey: 'hero.stat.experts' },
];